module.exports = {
      id: "whatsapp-icon-usage",
      viewBox: "0 0 24.99 25.091",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#whatsapp-icon",
      toString: function () {
        return this.url;
      }
    }